// FX Capital India — Bill Management front-end configuration
//
// API      = the Bill Management back end (orders, invoices, PCFC, banks etc.)
// AUTH_API = the existing rate-system login server (checks passwords, issues tokens)
//
// FOR LOCAL TESTING (running on your PC):
//   API:      'http://localhost:5036'
//   AUTH_API: 'https://fx.fxcapitalindia.in/api'
//
// FOR THE LIVE SERVER (trm subdomain — current deployment):
//   API:      'https://trm.fxcapitalindia.in/api'
//   AUTH_API: 'https://fx.fxcapitalindia.in/api'

const CONFIG = {
  API: 'https://trm.fxcapitalindia.in/api',
  AUTH_API: 'https://fx.fxcapitalindia.in/api'
};

export default CONFIG;